import React      from 'react';
import PropTypes  from 'prop-types';

const CompetitionTypeIcon = (type) =>
	<i className={`icon ${type === 'video' ? '-icon-videotake-full' : '-icon-smartphone-rings'}`} />;

CompetitionTypeIcon.propTypes = {
	type: PropTypes.string.isRequired,
};

export default CompetitionTypeIcon;